import { gql } from "@apollo/client"

export const SEGMENTATION_FRAGMENT = gql(`
  fragment SegmentationFragment on Segmentation {
    id
    name_fr
    name_en
  }
`)
